import LogCarrierNotes from './styled';

export default LogCarrierNotes;
